import {
    apiRequest,
    PetaJabatanListPeriod,
    PetaJabatanInactive,
    PetaJabatanHirarki,
    PetaJabatanHirarkiJabatan,
    checkmutasipegawai
} from "../../../../../services/adapters/kepegawaian/PetaJabatanService"

class IndexRepository {

    fetchListPeriod = async (query, cancelToken) => {
        return await apiRequest("get", PetaJabatanListPeriod, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", PetaJabatanInactive, {
            body: query
        }, true)
    }

    fetchHirarki = async (query, cancelToken) => {
        return await apiRequest('get', PetaJabatanHirarki, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

    fetchHirarkiJabatan = async (query, cancelToken) => {
        return await apiRequest('get', PetaJabatanHirarkiJabatan, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
}

export default IndexRepository